(() => {
  const timer = window.WeakMap ? new WeakMap() : new Map();
  const open = (elem) => {
    window.clearTimeout(timer.get(elem));
    timer.set(elem, window.setTimeout(() => {
      if (elem.getAttribute('aria-hidden') === 'true') {
        return;
      }

      window.swinger.overlayManager.open(elem);

      if (!elem.hasAttribute('data-showdurationseconds')) {
        return;
      }

      const seconds = Number(elem.getAttribute('data-showdurationseconds')) * 1000;
      window.clearTimeout(timer.get(elem));
      timer.set(elem, window.setTimeout(() => {
        window.swinger.overlayManager.close(elem);
      }, seconds));
    }));
  };

  window.swinger.eventHub.register('click', '.swinger-overlay__close', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('.swinger-overlay');
    window.swinger.overlayManager.close(elem);
    e.stopImmediatePropagation();
    return false;
  });

  window.swinger.observer.initialize('.swinger-overlay', (elem) => {
    if (elem.matches('.swinger-overlay--start-opened')) {
      open(elem);
    } else {
      const overlayId = elem.getAttribute('id').replace('swinger-overlay-', '');
      console.info(`Es ist ein geschlossenes Overlay vorhanden, das Sie mit folgendem Befehl öffnen können: window.swinger.overlayManager.open('${overlayId}')`);
    }
  }, false);
})();
